import React from 'react'
import { withTranslation } from 'react-i18next'
import * as UIcons from '@iconscout/react-unicons'
import useSWR from 'swr'
import SummaryCard from 'components/DetailWidgets/SummaryCard'
import useBalances from 'hooks/useBalances'
import { formatAmount } from 'Helper'

export default withTranslation()(function AccountSummary({ t }) {
  const { data: stats } = useSWR('dashboard/overview')
  const { credit, deposit, cash_flow } = useBalances()

  const items = [
    { icon: UIcons.UilPercentage, label: t('overview.platform_fee'), value: formatAmount(stats?.data?.platform_fee ?? 0) },
    { icon: UIcons.UilWallet, label: t('overview.credit'), value: formatAmount(credit?.balance ?? 0) },
    { icon: UIcons.UilImport, label: t('overview.deposit'), value: formatAmount(deposit?.balance ?? 0) },
    { icon: UIcons.UilArrowGrowth, label: t('overview.cashflow'), value: formatAmount(cash_flow?.balance ?? 0) }
  ]

  return <SummaryCard title={t('overview.account_summary')} items={items} />
})
